import React, { useEffect, useRef, useState } from 'react';
import MockupCreator from './MockupCreator'; // Import MockupCreator
import { Button } from 'flowbite-react';
import formConfig from './formConfig.json';

const ImageComponent = ({ previewSrc, loading, loadingImage, uploadedImageUrl, clientId = 'default' }) => {
  const containerRef = useRef(null);
  const [zoomPos, setZoomPos] = useState({ x: 0, y: 0 });
  const [isZoomed, setIsZoomed] = useState(false);
  const [zoomLevel, setZoomLevel] = useState(100); // 100% = 1x zoom
  const [imageLoaded, setImageLoaded] = useState(false);
  const [currentSrc, setCurrentSrc] = useState('');

  // Get the loadingText from formConfig, use default if not found
  const loadingText = formConfig[clientId]?.loadingText || formConfig.default.loadingText || "Creating Mockup";

  useEffect(() => {
    console.log('ImageComponent: previewSrc changed:', previewSrc);
    console.log('ImageComponent: uploadedImageUrl:', uploadedImageUrl);
    if (previewSrc !== currentSrc) {
      setImageLoaded(false);
      setCurrentSrc(previewSrc);
    }
  }, [previewSrc, currentSrc, uploadedImageUrl]);

  useEffect(() => {
    const handleWheel = (e) => {
      e.preventDefault();
      const zoomChange = e.deltaY * -0.01;
      const newZoomLevel = Math.min(Math.max(zoomLevel + zoomChange * 100, 100), 1000); // Clamp between 100% and 1000%
      setZoomLevel(newZoomLevel);
    };

    const containerEl = containerRef.current;
    if (containerEl) {
      containerEl.addEventListener('wheel', handleWheel, { passive: false });
    }

    return () => {
      if (containerEl) {
        containerEl.removeEventListener('wheel', handleWheel);
      }
    };
  }, [zoomLevel]);

  const handleMouseMove = (e) => {
    if (!isZoomed) return;

    const { left, top, width, height } = containerRef.current.getBoundingClientRect();
    const x = (e.pageX - left) / width * 100;
    const y = (e.pageY - top) / height * 100;
    setZoomPos({ x, y });
  };

  const handleImageLoad = () => {
    console.log('ImageComponent: Image loaded');
    setImageLoaded(true);
  };

  console.log('ImageComponent: Rendering. Loading:', loading, 'ImageLoaded:', imageLoaded);

  return (
    <div
      ref={containerRef}
      className="relative"
      onMouseEnter={() => setIsZoomed(true)}
      onMouseLeave={() => setIsZoomed(false)}
      onMouseMove={handleMouseMove}
      style={{ overflow: 'hidden', position: 'relative' }}
    >
      {(loading || !imageLoaded) && (
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 2,
        }}>
          <MockupCreator 
            mockupImageUrl={previewSrc}
            logoUrl={uploadedImageUrl}
            width="100%"
            height="100%"
            clientId={clientId}
            loadingText={loadingText}
          />
        </div>
      )}
      {previewSrc && (
        <img
          key={previewSrc} // Add a key to force re-render on src change
          src={previewSrc}
          alt="Preview"
          className="rounded-lg shadow-xl dark:shadow-gray-800 object-contain object-center"
          onLoad={handleImageLoad}
          style={{ display: imageLoaded ? 'block' : 'none' }}
        />
      )}
      {isZoomed && imageLoaded && !loading && (
        <div
          className="absolute w-48 h-48 rounded-lg shadow-xl border border-gray-300 overflow-hidden"
          style={{
            top: `${zoomPos.y}%`,
            left: `${zoomPos.x}%`,
            transform: 'translate(-50%, -50%)',
            backgroundImage: `url(${previewSrc})`,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: `${zoomPos.x}% ${zoomPos.y}%`,
            backgroundSize: `${zoomLevel}%`,
          }}
        />
      )}
    </div>
  );
};

export default ImageComponent;